module.exports = __webpack_public_path__ + "static/scale-model-of-the-washington-monument-in-baltimore-maryland-46871b361e99c535fbe9629964231a93.png";